import { CardNotice } from '@euler/app/flows/ai-suite/components/ChatCard';
import { parseBiUploadWidgetPayload } from '@euler/model/bi/widgets';
import { memo } from 'react';
import { UploadCard } from './UploadCard';

/**
 * The `bi_upload` fence: a spreadsheet on its way to datasets. The fence
 * carries the upload's id only; the card follows its live state.
 */
export const BiUploadWidget = memo(({ data }: { data: unknown }) => {
  const ref = parseBiUploadWidgetPayload(data);
  if (!ref) return <CardNotice text="这个表格的引用无效，请重新上传。" />;
  return <UploadCard key={ref.uploadId} uploadId={ref.uploadId} />;
});
